import CatalogSectionContainer from "./CatalogSectionContainer.jsx";

export default function NouveautesPage() {
    return <CatalogSectionContainer kind="new" />;
}
